import React, { useState } from 'react';
import { Button, Collapse, Stack } from '@mui/material';
import { BulkResultDetail } from 'organisms/CloudOpsReportAdmin/bulk/types';

const DETAILS_ID = 'bulk-result-details';

const reportIdentity = ({
  reportId,
  companyName,
  projectName,
}: BulkResultDetail) =>
  companyName && projectName
    ? `${companyName} / ${projectName}`
    : `Report #${reportId}`;

export const BulkResultDetails = ({
  details,
}: {
  details: BulkResultDetail[];
}) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <Stack alignItems="flex-start" gap={0.5}>
      <Button
        color="inherit"
        size="small"
        aria-expanded={expanded}
        aria-controls={DETAILS_ID}
        onClick={() => setExpanded((current) => !current)}
        sx={{ p: 0, minWidth: 0, textTransform: 'none' }}
      >
        {expanded ? 'Hide details' : `View details (${details.length})`}
      </Button>
      <Collapse in={expanded}>
        <Stack
          id={DETAILS_ID}
          role="region"
          aria-label="Bulk result details"
          component="ul"
          gap={0.75}
          sx={{
            m: 0,
            p: 1.5,
            pl: 3,
            bgcolor: 'error.50',
            color: 'text.primary',
            borderRadius: 1,
            maxHeight: 240,
            overflowY: 'auto',
            overflowWrap: 'anywhere',
          }}
        >
          {details.map((detail) => (
            <li key={`${detail.status}-${detail.reportId}`}>
              {`${
                detail.status === 'failed' ? 'Failed' : 'Skipped'
              } — ${reportIdentity(detail)} — ${detail.reason}`}
            </li>
          ))}
        </Stack>
      </Collapse>
    </Stack>
  );
};
